import React from 'react'
import { List } from 'antd'
import { Link } from 'react-router-dom'

import { LAYOUT_COMMON_USER_CHANGE_PASSWORD } from '../../../common/navigation'
import { EyeInvisibleOutlined } from '@ant-design/icons'

const ManagerInformation = (props) => {
  const { manager } = props

  if (!manager) {
    return null
  }
  return (
    <>
      {/* <div className="user-image m-b-20">
      <img />
      </div>
      */}
      <div className='personal-info'>
        <h2>{manager.name}</h2>
        <h4 className='user-designation m-b-10'>Manager</h4>
        <List.Item style={{ padding: '0px 0px' }}>
          <Link to={LAYOUT_COMMON_USER_CHANGE_PASSWORD}>
            <EyeInvisibleOutlined /> Change password
          </Link>
        </List.Item>
      </div>
      <div className='contact-info'>
        <h2 className='after-underline'>Contact Information</h2>
        <div className='m-t-15 m-b-20'>
          <List.Item style={{ padding: '0px 0px' }}>
            <List.Item.Meta title='E-Mail' description={manager.email} />
          </List.Item>
          <List.Item style={{ padding: '0px 0px' }}>
            <List.Item.Meta title='Skype' description={manager.skype} />
          </List.Item>
          <List.Item style={{ padding: '0px 0px' }}>
            <List.Item.Meta title='Phone' description={manager.phone} />
          </List.Item>
        </div>
      </div>
    </>
  )
}

ManagerInformation.defaultProps = {
  manager: {}
}

export default ManagerInformation
